import React, { useState, useEffect } from "react";
import "../../css/CRUDModal.css";
import CustomAlert from "../../helpers/CustomAlert";
import { axiosPostApi } from "../../helpers/interceptorServices";
import { apiList } from "../../helpers/apiList";
import Swal from "sweetalert2";
import { CircularProgress } from "@mui/material";

const ViewAccDetailModal = ({ show, handleClose }) => {
  const loggedInUserName = sessionStorage.getItem("username");

  const [loading, setLoading] = useState(false);
  const [accData, setAccData] = useState(null);

  const fetchAppanTechAccInfo = async () => {
    const payload = {
      username: loggedInUserName,
    };
    try {
      setLoading(true);
      const response = await axiosPostApi(
        apiList.FETCH_APPANTECH_ACC_DETAILS,
        payload
      );
      if (response?.status === 200 && response?.data?.respCode === "00") {
        const data = response?.data?.data || [];
        setAccData(data);

        setLoading(false);
      } else if (response?.data?.respCode === "01") {
        handleClose();
        CustomAlert({
          title: "Data Fetch Error",
          text:
            response?.data?.message ||
            "No data available for the specified criteria.",
          icon: "error",
          confirmButtonText: "Retry",
        });
      }
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: `There was an error: ${error?.message}`,
        icon: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (show) {
      fetchAppanTechAccInfo();
    }
  }, [show]);

  const handleAddUser = (e) => {
    e.preventDefault();
  };

  const handleBack = () => {
    handleClose();
  };

  return (
    <>
      {show && (
        <div
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1060,
          }}
        >
          <div className="modal-dialog" role="document">
            <div
              className="modal-content"
              style={{
                // width: "597px",
                borderRadius: "24px",
                padding: "24px",
                backgroundColor: "#FFF",
                border: "1px solid rgba(0, 0, 0, 0.175)",
              }}
            >
              <div
                className="modal-header"
                style={{
                  padding: "1rem 1rem",
                  borderBottom: "1px solid #dee2e6",
                }}
              >
                <h5 className="modal-title main-title">Account Details</h5>
              </div>
              <form onSubmit={(e) => handleAddUser(e)}>
                <div
                  className="scoped-modal modal-body"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "24px",
                  }}
                >
                  {loading ? (
                    <div className="loading-container">
                      <CircularProgress />
                    </div>
                  ) : (
                    <div className="table-container">
                      <div className="table-wrapper">
                        <table className="custom-table">
                          <thead>
                            <tr>
                              <th>Bank Name</th>
                              <th>Acc Holder Name</th>
                              <th>Acc Number</th>
                              <th>IFSC Code</th>
                            </tr>
                          </thead>
                          <tbody>
                            {accData?.map((item) => (
                              <tr
                                key={item.id}
                                style={{
                                  borderBottom: "1px solid #dee2e6",
                                }}
                              >
                                <td>{item?.bankName}</td>
                                <td>{item?.holderName}</td>
                                <td>{item?.accountNumber}</td>
                                <td>{item?.ifscCode}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}
                </div>

                <div
                  className="scoped-modal"
                  style={{
                    display: "flex",
                    justifyContent: "end",
                    padding: "12px",
                    paddingBottom: "0px",
                    gap: "16px",
                    borderTop: "1px solid #dee2e6",
                  }}
                >
                  <button
                    type="button"
                    className="btn btn-back"
                    onClick={handleBack}
                    style={{ width: "150px", height: "52px" }}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ViewAccDetailModal;
